import React from 'react';

const GhostActionButton: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = ({
  children,
  className = '',
  type = 'button',
  ...props
}) => (
  <button
    type={type}
    className={`inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white transition hover:bg-white/12 disabled:cursor-not-allowed disabled:opacity-50 ${className}`.trim()}
    {...props}
  >
    {children}
  </button>
);

export default GhostActionButton;

